export class ChangeDigitalSignatureMessage {
	type: string;
	hasButton: boolean;
	title: string;
	text: string;
	buttonTitle = 'Continuar';
	eventToDispatch: string;
	eventData: any;
	delay: number;
	withPreload: boolean;
	delayToDispatchEvent = 0;
	cpf: any;
	password: any;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/model/change-digital-signature-message.ts